import { render } from "./Dots.vue?vue&type=template&id=8295cc84&scoped=true"
const script = {}

import "./Dots.vue?vue&type=style&index=0&id=8295cc84&lang=scss&scoped=true"

import exportComponent from "/builds/sats/careers-application/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8295cc84"]])

export default __exports__